/**
 * @constant
 * @type {{CLASS_NAME: string, ID: string}}
 */
const WELCOME_DEFAULT_PROPERTIES = {
    CLASS_NAME: 'WelcomeComponentController',
    ID: '#cgp-directive-welcome',
    CLASS: '.cgp-directive-welcome'
};


const LAYOUT_PATTERN = {
    BUTTONS: {
        login: {
            layout: 'buttons'
        },
        loggedin: {
            layout: 'inline'
        }
    },
    FORM: {
        login: {
            layout: 'form'
        },
        loggedin: {
            layout: 'inline'
        }
    },
    'GAME-PANEL': {
        login: {
            layout: 'buttons'
        },
        loggedin: {
            layout: 'cashier_only'
        }
    }
};


const LAYOUT_TYPE = {
    DEFAULT_TYPE: 2
};


export {WELCOME_DEFAULT_PROPERTIES, LAYOUT_PATTERN, LAYOUT_TYPE}